import { ChangeDetectorRef, Component, effect } from '@angular/core';
import { NgIf } from '@angular/common';
import { NbIconModule } from '@nebular/theme';
import { StateService } from '../../@core/utils/state.service';
import { NavigationHelpers } from '../../common/utils';
import { relatedUserSlug } from '../../../hh_platform_frontend/docs/app/app.paths';
import { Router } from '@angular/router';

@Component({
  selector: 'pinned-user-badge',
  standalone: true,
  imports: [NgIf, NbIconModule],
  templateUrl: './pinned-user-badge.component.html',
  styleUrls: ['./pinned-user-badge.component.scss']
})
export class PinnedUserBadgeComponent {

  user: any = null;
  displayName = '';

  constructor( private state: StateService, private navigate: NavigationHelpers, private cdr: ChangeDetectorRef, public router: Router) {
    effect(() => {
      const u = this.state.pinnedUser$();
      console.devlog('[PinnedUserBadge] effect fired, signal value:', u);
      this.user = u;
      this.displayName = this.buildName(u);
      this.cdr.markForCheck();
    });
  }

  private buildName(u: any): string {
    if (!u) return '';
    const parts = [u.firstName, u.lastName].filter(Boolean);
    return parts.length ? parts.join(' ') : (u.matricule || u.email || 'Pinned user');
  }

  open() {
    if (!this.user?.documentId) return;
   this.router.navigate(['/f', relatedUserSlug, this.user.documentId, 'info']);
  }

  clear(event: MouseEvent) {
    event.stopPropagation();
    this.state.clearPinnedUser();
  }
}
